import { IconName } from '../../Atoms/Icon/Icon.enum';
import { ToastrType } from './Toastr.interface';
const getToastrTypeIconSetup = (theme, type) => {
    switch (type) {
        case ToastrType.SUCCESS:
        default:
            return { color: theme.colors.supportSuccess01, iconName: IconName.SUCCESS };
        case ToastrType.ERROR:
            return { color: theme.colors.supportError01, iconName: IconName.ALERT };
        case ToastrType.INFO:
            return { color: theme.colors.supportInfo01, iconName: IconName.ALERT };
        case ToastrType.WARNING:
            return { color: theme.colors.supportWarning01, iconName: IconName.WARNING };
    }
};
export { getToastrTypeIconSetup };
//# sourceMappingURL=Toastr.helpers.js.map